import AutomationError from './AutomationError';
class InvestorHasInvalidTaxId extends AutomationError {
    constructor(options) {
        super('The investor’s tax id is not valid.', options);
    }
}
export default InvestorHasInvalidTaxId;
